import { useDisclosure } from '@chakra-ui/react'
import { selectAuthenticatedUser, useSelector } from '@missionlabs/api'
import { readFile } from '@missionlabs/utils'
import { RecordingDrawer } from 'features/settings/components/RecordingDrawer'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCreateUserAudioClipMutation } from 'shared/store'

export const AddRecordingDrawer: FC = () => {
    const navigate = useNavigate()
    const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true })

    const user = useSelector(selectAuthenticatedUser)

    const [createUserAudioClip, { isLoading }] = useCreateUserAudioClipMutation()

    async function handleSubmit(file: File | null) {
        if (!user || !file) return

        try {
            const dataURL = await readFile(file)
            if (!dataURL) return
            await createUserAudioClip({
                userID: user.userID,
                data: dataURL,
                label: file?.name
            }).unwrap()
        } catch (e) {
            console.error(e)
        }
    }

    function handleTransition() {
        navigate('/settings/recordings')
    }

    return (
        <RecordingDrawer
            isLoading={isLoading}
            isOpen={isOpen}
            onClose={onClose}
            onCloseComplete={handleTransition}
            onSubmit={handleSubmit}
        />
    )
}
